import React from 'react';

import { FirmRfiRequestStatus } from '@liscio/api';
import { Chip } from '@liscio/ui';

type StatusCellProps = {
  status: FirmRfiRequestStatus;
};

const statusColors: Record<FirmRfiRequestStatus, 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'> = {
  draft: 'default',
  sent_to_client: 'primary',
  opened: 'info',
  in_progress: 'info',
  submitted: 'success',
  archived: 'secondary',
  recalled: 'warning',
  deleted: 'error',
};

export const statusLabels: Record<FirmRfiRequestStatus, string> = {
  draft: 'Draft',
  sent_to_client: 'Sent to Client',
  opened: 'Opened',
  in_progress: 'In Progress',
  submitted: 'Submitted',
  archived: 'Archived',
  recalled: 'Recalled',
  deleted: 'Deleted',
};

export const StatusCell = ({ status }: StatusCellProps) => {
  return (
    <Chip
      label={statusLabels[status]}
      color={statusColors[status]}
      size="small"
      sx={{ width: 120, justifyContent: 'center', opacity: 0.85, fontSize: '0.8125rem', fontWeight: 500 }}
    />
  );
};
